export class CustomRegulars {
}
/**
 * 特殊字符
 * @examples
 */
CustomRegulars.special_characters = /[`~!@#$%^&*+=?:"{}|,.\/;'\\[\]·~！@#￥%……&*+={}|？：“”【】、；‘'，。、]/gim;
/**
 * 密码强度校验， 必须为8-20位  可以设置大写字母、小写字母、数字和部分特殊字符 必须同时包含三种组合及以上
 * @examples  ['123456Zy']
 */
CustomRegulars.passwordRule = /^(?![A-Za-z]+$)(?![A-Z\d]+$)(?![A-Z\W]+$)(?![a-z\d]+$)(?![a-z\W]+$)(?![\d\W]+$)\S{8,20}$/;
/**
 * 真实姓名（同为中文或同为英文）
 * @examples ['James', '小明', 'Dirk Nowitzki']
 */
CustomRegulars.real_name = /^(?:[\u4e00-\u9fa5]{2,50}|[a-zA-Z]{2,50})$/;
/**
 * 纯中文/纯英文
 * @examples  ['#f00', '#F90', '#000', '#fe9de8']
 */
CustomRegulars.chinese_or_english = /^[A-z]+$|^[\u4E00-\u9FA5]+$/;
/**
 * 邮箱
 * @examples  不能有中文
 */
CustomRegulars.email = /^[^\u4e00-\u9fa5][A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,6}$/;
